// Package Imports
import { Space, Typography } from 'antd'

const { Text } = Typography

export default function AuthFooter() {
  return (
    <Space
      orientation="vertical"
      size={4}
      align="center"
      className="w-full border-t border-gray-100 pt-5 text-center"
    >
      <Text type="secondary" className="text-xs">
        © {new Date().getFullYear()} BilgiLig. Tüm hakları saklıdır.
      </Text>
    </Space>
  )
}
